/**
 * Created by mac on 4/20/20
 */

const LevelManager = function () {

};

LevelManager.prototype.updateLoadedLevel = function () {
    const level = cleverapps.administrator.adminLevels.levels[this.level.levelNo];
    this.levelVersions = level.getLevelVersions();
};

LevelManager.prototype.setLevel = function (options) {
    if (this.levelBundleId) {
        cleverapps.bundleLoader.deleteBundle(this.levelBundleId);
    }

    cleverapps.bundleLoader.clearUnusedResources();

    const level = this.level = new Level(options.episodeNo, options.levelNo, options);

    this.levelBundleId = level.bundleId();

    cleverapps.bundleLoader.loadBundle(this.levelBundleId, {
        onSuccess: () => {
            level.setupContent();

            this.updateLoadedLevel();
        }
    });

    this.setVersion(undefined);
};

LevelManager.getInstance = function () {
    if (!LevelManager.currentManager) {
        LevelManager.currentManager = new LevelManager();
    }

    return LevelManager.currentManager;
};

LevelManager.prototype.playLevel = function (f) {
    if (cleverapps.config.adminMode) {
        cleverapps.setUrlHash({ playLevel: true });
    }

    if (cleverapps.knockoutGame) {
        if (!cleverapps.knockoutGame.isRumble()) {
            cleverapps.knockoutGame.rumble = new Rumble();
        }
        cleverapps.knockoutGame.rumble.whenInitialize((success) => {
            if (success) {
                this.level.play(f);
            } else {
                cleverapps.knockoutGame.onRumbleInitFailed();
            }
        });

        return;
    }

    if (cleverapps.config.type === "merge") {
        cleverapps.config.adminMode = false;
        cleverapps.flags.norest = true;
        cleverapps.setRestDummies(true);
    }

    cleverapps.meta.switchLocation(Administrator.guessLocation(this.level));

    this.level.play(f);
};

LevelManager.prototype.editLevel = function (f) {
    this.level.edit(f);
};

LevelManager.prototype.setVersion = function (version) {
    this.version = version;
};

LevelManager.prototype.getMaxVersion = function () {
    const level = cleverapps.administrator.adminLevels.levels[this.level.levelNo];
    return level.getActiveVersion();
};

LevelManager.prototype.getMaxVersionContent = function () {
    return this.levelVersions[this.getMaxVersion()];
};

LevelManager.prototype.prepareEdit = function () {
    if (this.version === undefined) {
        this.showAlertMessage("Unknown version.");
        return false;
    }

    if (this.version < this.getMaxVersion()) {
        this.showAlertMessage("You must edit last version.");
        return false;
    }

    if (this.version === this.level.playedProductionMaxVersion) {
        if (confirm("Create new version for edit.")) {
            this.createNewVersion();
            this.editLevel();
        }
        return false;
    }

    return true;
};

LevelManager.prototype.showAlertMessage = cleverapps.throttle(100, (message) => {
    alert(message);
});

LevelManager.prototype.createNewVersion = function () {
    const maxVersion = this.getMaxVersion();

    if (maxVersion > this.level.playedProductionMaxVersion) {
        this.showAlertMessage("Level hasn't played on production yet. You can't increase version!");
        return;
    }

    const data = cleverapps.clone(this.levelVersions[maxVersion], true);
    data.creationTime = new Date().toString();
    this.setVersion(maxVersion + 1);
    this.update(data);

    this.save(() => {
        cleverapps.administrator.log.createEntry({
            type: AdminLog.CREATE_LEVEL_VERSION,
            episodeNo: data.episodeNo,
            levelNo: data.levelNo,
            version: data.version
        });
    });
};

LevelManager.prototype.update = function (data) {
    data.episodeNo = cleverapps.castType(this.level.episodeNo);
    data.levelNo = this.level.levelNo;
    data.version = this.version || this.getMaxVersion();

    this.levelVersions[data.version] = data;

    const levels = Object.values(this.levelVersions);
    const adminEpisode = cleverapps.administrator.adminEpisodes.getEpisode(data.episodeNo);
    adminEpisode.getEpisodeLevels()[data.levelNo] = levels.length > 1 ? levels : levels[0];
};

LevelManager.prototype.save = function (onSuccess) {
    const adminEpisode = cleverapps.administrator.adminEpisodes.getEpisode(this.level.episodeNo);
    cleverapps.administrator.adminEpisodes.saveToStorage(this.level.episodeNo, adminEpisode.getEpisodeLevels());

    if (onSuccess) {
        onSuccess();
    }
};

LevelManager.prototype.processLevelContent = function (processor) {
    const content = this.level.content;

    processor(content);

    this.update(content);
    this.save();
};
